import { render, staticRenderFns } from "./DocImpressumView.vue?vue&type=template&id=0f213c6e&scoped=true"
import script from "./DocImpressumView.vue?vue&type=script&lang=js"
export * from "./DocImpressumView.vue?vue&type=script&lang=js"
import style0 from "./DocImpressumView.vue?vue&type=style&index=0&id=0f213c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f213c6e",
  null
  
)

export default component.exports